"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.texSize3 = void 0;
var FontData_js_1 = require("../../FontData.js");
var tex_size3_js_1 = require("../../../common/fonts/tex/tex-size3.js");
exports.texSize3 = (0, FontData_js_1.AddCSS)(tex_size3_js_1.texSize3, {
    0x2044: { c: '/' },
    0x2329: { c: '\\27E8' },
    0x232A: { c: '\\27E9' },
    0x3008: { c: '\\27E8' },
    0x3009: { c: '\\27E9' },
});
//# sourceMappingURL=tex-size3.js.map